import { currentUserLocalStorage } from "services/storage/general";
import doRequest from "../helpers";
import { getToken } from "services/auth/tokenAuth";

export const requestGetEventDataForAttendance = async dateEventId => {
	const [result, err] = await doRequest(
		`/EventoCultural/DatosAsistencia/${dateEventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const {
		idEvento,
		idEventoCulturalFecha,
		esTaller,
		titulo,
		diaUnico,
		variosDias,
		esPresencial,
		fecha,
		horaInicio,
		horaFin,
	} = data.data.datosAsistencia;
	return {
		eventId: idEvento,
		dateEventId: idEventoCulturalFecha,
		title: titulo,
		formattedDate: {
			onlyDay: diaUnico,
			manyDays: variosDias
				? {
						start: variosDias.inicio,
						end: variosDias.fin,
				  }
				: null,
		},
		isWorkShop: esTaller,
		isPresential: esPresencial,
		schedule: {
			date: fecha,
			time: {
				start: horaInicio,
				end: horaFin,
			},
		},
	};
};
export const requestGetStudentsEventReservation = async dateEventId => {
	const [result, err] = await doRequest(
		`/EventoCultural/ReservaAlumno/${dateEventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const { listaAlumnos } = data.data;
	return listaAlumnos.map(
		({
			codigoAlumno: id,
			idReserva: reservationId,
			nombres: name,
			asistencia: attendance,
			fechaInscripcion: inscriptionDate
		}) => {
			return {
				reservationId,
				id,
				name,
				attendance,
				inscriptionDate
			};
		}
	);
};
export const requestGetStudentsSanctioned = async eventId => {
	const [result, err] = await doRequest(
		`/Evento/ReporteSancionados/${eventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const { sancionados } = data.data;
	return sancionados.map(
		({
			codigoAlumno: id,
			estado: state,
			nombres: name,
			fechaSancion: sanctionDate,
			fechaInscripcion: inscriptionDate
		}) => {
			return {
				state,
				id,
				name,
				sanctionDate,
				inscriptionDate
			};
		}
	);
};
export const requestAddStudentToEventReservation = async ({
	id,
	dateEventId,
}) => {
	const [result, err] = await doRequest(
		"/ReservaEvento/Crear",
		"POST",
		{
			codigoAlumno: id,
			idEventoCulturalFecha: dateEventId,
		},
		getToken()
	);
	if (err) 
		return {
			success: false,
			message: null
		};
	const { data: payload } = result;
	if (payload?.state === 0) 
		return {
			success: false,
			message: payload?.data?.descripcion || null
		};
	if (payload?.state === 1)
		return {
			success: true,
			message: null
		};
	return {
		success: false,
		message: null
	};
};

export const requestSaveEventAttendanceStudent = async (
    studentAttendance = []
) => {
    const currentUser = currentUserLocalStorage.get();
    const [result, err] = await doRequest(
        "/GuardarAsistenciaEvento",
        "POST",
        {
            usuarioCreacion: currentUser.id,
            alumnoReservas: studentAttendance.map(
                ({ reservationId: idReserva, attendance: asistencia }) => {
                    return {
                        idReserva,
                        asistencia,
                    };
                }
            ),
        },
        getToken()
    );

    if (err) {
        return {
            success: false,
            message: "Error en la solicitud al servidor.",
        };
    }

    const { data } = result;

    // Validar el estado de la respuesta
    if (data?.state === 0) {
        return {
            success: false,
            message: data?.msg || "No se pudo guardar la asistencia.",
        };
    }

    if (data?.state === 1) {
        return {
            success: true,
            message: data?.msg || "Asistencia guardada correctamente.",
            data: data?.data || null,
        };
    }

    // Respuesta inesperada
    return {
        success: false,
        message: "Respuesta inesperada del servidor.",
    };
};

export const requestTakeTeacherAttendance = async ({
	dateEventId,
	isCheckIn,
}) => {
	const [result, err] = await doRequest(
		"/EventoCultural/TomarAsistenciaDocente",
		"POST",
		{
			idEventoCulturalFecha: dateEventId,
			esEntrada: isCheckIn,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};
export const requestGetInfoTeacherAttendance = async dateEventId => {
	const [result, err] = await doRequest(
		`/EventoCultural/LeerAsistenciaDocente/${dateEventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result.data;
	if ([0, 1].includes(data?.state)) return null;
	const { horaEntrada, horaSalida, minutosTranscurridos } =
		data.asistenciaDocente;
	return {
		checkInTime: horaEntrada,
		checkOutTime: horaSalida,
		classTime: minutosTranscurridos,
	};
};
//#endregion
